(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["home-product-card"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.capriHomeCardHover) return;
    window.capriHomeCardHover = true;

    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    document.addEventListener(
      'pointerover',
      (event) => {
        if (event.pointerType !== 'mouse' || !finePointer.matches) return;
        const card = event.target instanceof Element ? event.target.closest('.home-card') : null;
        const img = card?.querySelector('img[data-hover-srcset]');
        if (!img) return;
        img.addEventListener('load', () => img.classList.add('is-loaded'), { once: true });
        img.sizes = img.dataset.hoverSizes || '';
        img.srcset = img.dataset.hoverSrcset;
        img.removeAttribute('data-hover-srcset');
      },
      { passive: true }
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-donation-banner"] && !Shopify.designMode) return;
  try {
    const hydrateProductDonationBenefits = (root = document) => {
    root.querySelectorAll('media-gallery, wall-art-gallery').forEach((gallery) => {
      const track = gallery.querySelector('[data-product-donation-mobile-benefits]');
      const benefitItems = gallery.querySelectorAll('.product-media-primary-squares__item');
      const staticMessage = gallery.querySelector('.product-donation-banner__static');

      if (!track || track.dataset.benefitsReady === 'true') return;

      const only = track.dataset.only;
      let shown = 0;
      const appendMobileBenefit = (icon, label) => {
        const slide = document.createElement('span');

        if (!icon || !label || (only && label !== only)) return;
        const index = shown;
        shown += 1;

        icon.removeAttribute('class');
        icon.setAttribute('aria-hidden', 'true');
        icon.setAttribute('focusable', 'false');
        icon.querySelectorAll('[stroke]').forEach((node) => {
          if (node.getAttribute('stroke') !== 'none') node.setAttribute('stroke', 'currentColor');
        });
        icon.querySelectorAll('[fill]').forEach((node) => {
          if (node.getAttribute('fill') !== 'none') node.setAttribute('fill', 'currentColor');
        });

        slide.className = 'product-donation-banner__mobile-benefit';
        slide.style.setProperty('--benefit-index', index);
        slide.append(icon);

        const text = document.createElement('span');
        text.className = 'product-donation-banner__mobile-benefit-text';
        text.textContent = (only && track.dataset.onlyText) || label;
        slide.append(text);

        track.append(slide);
      };

      const staticSourceIcon = staticMessage ? staticMessage.querySelector('svg') : null;
      const staticSourceLabel = staticMessage ? staticMessage.querySelector('.product-donation-banner__text') : null;
      const staticIcon = staticSourceIcon ? staticSourceIcon.cloneNode(true) : null;
      const staticLabel = staticSourceLabel ? staticSourceLabel.textContent.trim() : '';
      appendMobileBenefit(staticIcon, staticLabel);

      benefitItems.forEach((item) => {
        const sourceIcon = item.querySelector('svg');
        const sourceLabel = item.querySelector('.product-media-primary-squares__label');
        const icon = sourceIcon ? sourceIcon.cloneNode(true) : null;
        const rawLabel = sourceLabel ? sourceLabel.textContent.trim() : '';
        const label = rawLabel === 'USA Made' ? 'Proudly made in the USA' : rawLabel;

        appendMobileBenefit(icon, label);
      });

      const slideCount = track.querySelectorAll('.product-donation-banner__mobile-benefit').length;
      track.style.setProperty('--benefit-cycle', `${slideCount * 5}s`);
      track.classList.toggle('is-single', slideCount === 1);

      track.dataset.benefitsReady = 'true';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => hydrateProductDonationBenefits());
  } else {
    hydrateProductDonationBenefits();
  }

  document.addEventListener('shopify:section:load', (event) => hydrateProductDonationBenefits(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wall-art-customer-gallery"] && !Shopify.designMode) return;
  try {
    class ProductCustomerGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-customer-gallery-track]');
      this.thumb = this.querySelector('[data-customer-gallery-thumb]');
      this.scrollbar = this.thumb ? this.thumb.parentElement : null;

      if (!this.track || !this.thumb || !this.scrollbar) return;

      this.updateScrollbar = this.updateScrollbar.bind(this);
      this.handleWheel = this.handleWheel.bind(this);
      this.handlePointerDown = this.handlePointerDown.bind(this);
      this.handlePointerMove = this.handlePointerMove.bind(this);
      this.handlePointerUp = this.handlePointerUp.bind(this);
      this.handleImageContextMenu = this.handleImageContextMenu.bind(this);
      this.flushScroll = this.flushScroll.bind(this);

      this.track.addEventListener('scroll', this.updateScrollbar, { passive: true });
      this.addEventListener('contextmenu', this.handleImageContextMenu);
      this.addEventListener('wheel', this.handleWheel, { passive: false });
      this.thumb.addEventListener('pointerdown', this.handlePointerDown);
      this.thumb.addEventListener('pointermove', this.handlePointerMove);
      this.thumb.addEventListener('pointerup', this.handlePointerUp);
      this.thumb.addEventListener('pointercancel', this.handlePointerUp);
      window.addEventListener('resize', this.updateScrollbar);

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.updateScrollbar);
        this.resizeObserver.observe(this.track);
      }

      this.updateScrollbar();
    }

    disconnectedCallback() {
      if (this.track) {
        this.track.removeEventListener('scroll', this.updateScrollbar);
      }

      this.removeEventListener('wheel', this.handleWheel);
      this.removeEventListener('contextmenu', this.handleImageContextMenu);

      if (this.thumb) {
        this.thumb.removeEventListener('pointerdown', this.handlePointerDown);
        this.thumb.removeEventListener('pointermove', this.handlePointerMove);
        this.thumb.removeEventListener('pointerup', this.handlePointerUp);
        this.thumb.removeEventListener('pointercancel', this.handlePointerUp);
      }

      window.removeEventListener('resize', this.updateScrollbar);

      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }

      if (this.scrollFrame) {
        window.cancelAnimationFrame(this.scrollFrame);
      }
    }

    handleImageContextMenu(event) {
      if (!event.target.closest('.product-customer-gallery__image')) return;

      event.preventDefault();
    }

    handleWheel(event) {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;

      if (maxScroll <= 1) return;

      const delta = this.normalizeWheelDelta(event);
      if (delta === 0) return;

      const currentScroll = typeof this.pendingScrollLeft === 'number' ? this.pendingScrollLeft : this.track.scrollLeft;
      const targetScroll = Math.max(0, Math.min(maxScroll, currentScroll + delta * 0.75));

      if (targetScroll === currentScroll) return;

      event.preventDefault();
      this.queueScroll(targetScroll);
    }

    handlePointerDown(event) {
      if (event.button !== 0) return;

      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      if (maxScroll <= 1) return;

      event.preventDefault();
      this.dragOffsetX = event.clientX - this.thumb.getBoundingClientRect().left;
      this.isDragging = true;
      this.thumb.classList.add('is-dragging');
      this.thumb.setPointerCapture(event.pointerId);
    }

    handlePointerMove(event) {
      if (!this.isDragging) return;

      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const maxThumbOffset = this.scrollbar.clientWidth - this.thumb.offsetWidth;

      if (maxScroll <= 1 || maxThumbOffset <= 0) return;

      const scrollbarRect = this.scrollbar.getBoundingClientRect();
      const thumbLeft = Math.max(0, Math.min(maxThumbOffset, event.clientX - scrollbarRect.left - this.dragOffsetX));
      const progress = thumbLeft / maxThumbOffset;

      event.preventDefault();
      this.queueScroll(progress * maxScroll);
    }

    handlePointerUp(event) {
      if (!this.isDragging) return;

      this.isDragging = false;
      this.thumb.classList.remove('is-dragging');

      if (this.thumb.hasPointerCapture(event.pointerId)) {
        this.thumb.releasePointerCapture(event.pointerId);
      }
    }

    normalizeWheelDelta(event) {
      const absoluteDeltaX = Math.abs(event.deltaX);
      const absoluteDeltaY = Math.abs(event.deltaY);
      const horizontalGesture = absoluteDeltaX > absoluteDeltaY;
      const primaryDelta = horizontalGesture ? event.deltaX : event.deltaY;
      const unit = event.deltaMode === WheelEvent.DOM_DELTA_LINE ? 28 : event.deltaMode === WheelEvent.DOM_DELTA_PAGE ? this.track.clientWidth : 1;

      return primaryDelta * unit;
    }

    queueScroll(value) {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;

      this.pendingScrollLeft = Math.max(0, Math.min(maxScroll, value));

      if (this.scrollFrame) return;

      this.scrollFrame = window.requestAnimationFrame(this.flushScroll);
    }

    flushScroll() {
      this.scrollFrame = 0;
      this.track.scrollLeft = this.pendingScrollLeft;
      this.pendingScrollLeft = null;
    }

    updateScrollbar() {
      const scrollWidth = this.track.scrollWidth;
      const visibleWidth = this.track.clientWidth;
      const maxScroll = scrollWidth - visibleWidth;

      if (maxScroll <= 1) {
        this.thumb.style.setProperty('--customer-gallery-thumb-width', '100%');
        this.thumb.style.setProperty('--customer-gallery-thumb-offset', '0%');
        this.thumb.setAttribute('aria-valuenow', '0');
        return;
      }

      const thumbWidth = Math.min(Math.max((visibleWidth / scrollWidth) * 100, 8), 28);
      const progress = this.track.scrollLeft / maxScroll;
      const offset = progress * (100 - thumbWidth);

      this.thumb.style.setProperty('--customer-gallery-thumb-width', `${thumbWidth}%`);
      this.thumb.style.setProperty('--customer-gallery-thumb-offset', `${offset}%`);
      this.thumb.setAttribute('aria-valuenow', String(Math.round(progress * 100)));
    }
  }

  if (!customElements.get('product-customer-gallery')) {
    customElements.define('product-customer-gallery', ProductCustomerGallery);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wall-art-option-pills"] && !Shopify.designMode) return;
  try {
    function setupProductOptionPills(root) {
    if (!root || root.dataset.productOptionPillsReady === 'true') return;

    root.dataset.productOptionPillsReady = 'true';

    var variantsDataScript = root.querySelector('[data-product-option-pills-variants]');
    var variantsData = {
      productId: root.dataset.productId,
      productUrl: root.dataset.productUrl,
      sectionId: root.dataset.sectionId,
      variants: [],
    };
    var selectedValues = {};

    try {
      if (variantsDataScript && variantsDataScript.textContent) {
        variantsData = JSON.parse(variantsDataScript.textContent);
      }
    } catch (error) {
      console.error('Failed to parse product option pills variant data:', error);
    }

    function getActiveButton(groupName) {
      return root.querySelector('[data-option-group-name="' + groupName + '"][aria-pressed="true"]');
    }

    function getOptionValue(groupName) {
      var activeButton = getActiveButton(groupName);
      return activeButton ? activeButton.dataset.optionValue : '';
    }

    function getOptionLabel(groupName) {
      var activeButton = getActiveButton(groupName);
      return activeButton ? activeButton.dataset.optionLabel : '';
    }

    function normalizeSizeValue(value) {
      if (!value) return '';
      return value.indexOf('"') === -1 ? value + '"' : value;
    }

    function normalizeColorValue(value) {
      if (!value) return '';
      return value.charAt(0).toUpperCase() + value.slice(1);
    }

    function getSelectedOptions() {
      var format = selectedValues.format || getOptionValue('format');
      var size = selectedValues.size || getOptionValue('size');
      var color = selectedValues.color || getOptionValue('color');

      return {
        format: normalizeColorValue(format),
        size: normalizeSizeValue(size),
        color: format === 'printed' ? 'NA' : normalizeColorValue(color),
      };
    }

    function findSelectedVariant() {
      var options = getSelectedOptions();

      return variantsData.variants.find(function(variant) {
        return variant.option1 === options.format && variant.option2 === options.size && variant.option3 === options.color;
      });
    }

    function findVariantById(variantId) {
      if (!variantId) return null;

      return variantsData.variants.find(function(variant) {
        return variant.id === variantId;
      });
    }

    function getButtonValueFromVariantOption(groupName, value) {
      if (!value) return '';

      if (groupName === 'size') {
        return value.replace('"', '');
      }

      return value.toLowerCase();
    }

    function setGroupFromVariantOption(groupName, value) {
      var buttonValue = getButtonValueFromVariantOption(groupName, value);
      var button = root.querySelector(
        '[data-option-group-name="' + groupName + '"][data-option-value="' + buttonValue + '"]'
      );

      if (!button) return;

      setGroupValue(groupName, button.dataset.optionValue, button.dataset.optionLabel);
    }

    function setControlsFromVariant(variant) {
      if (!variant) return;

      setGroupFromVariantOption('format', variant.option1);
      setGroupFromVariantOption('size', variant.option2);

      if (variant.option1 !== 'Printed' && variant.option3 !== 'NA') {
        setGroupFromVariantOption('color', variant.option3);
      }
    }

    function findProductForm() {
      var section = root.closest('.shopify-section');
      if (!section) return null;

      return section.querySelector('[data-wall-art-form]');
    }

    function updateProductFormVariant(variant) {
      var productForm = findProductForm();
      var variantIdInput = productForm ? productForm.querySelector('input[name="id"]') : null;

      if (variantIdInput) {
        variantIdInput.value = variant ? variant.id : '';
        variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function updateUrl(variant) {
      if (!variant || !root.dataset.productUrl) return;

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);

      window.requestAnimationFrame(function() {
        history.replaceState({}, '', url.toString());
      });
    }

    function updatePrice(variant) {
      if (!variant) return;

      var section = root.closest('.shopify-section');
      var price = section ? section.querySelector('product-price') : null;
      if (!price) return;

      setPriceText(price, variant);
    }

    function setPriceText(price, variant) {
      var regularPrice = price.querySelector('.price__regular .price');
      var salePrice = price.querySelector('.price__sale .price-item--sale');
      var compareAtPrice = price.querySelector('.price__sale .compare-at-price');
      var regularPriceWrapper = price.querySelector('.price__regular');
      var salePriceWrapper = price.querySelector('.price__sale');
      var showComparePrice = variant.compare_at_price && variant.compare_at_price > variant.price;

      if (regularPrice) regularPrice.textContent = variant.formatted_price;
      if (salePrice) salePrice.textContent = variant.formatted_price;
      if (compareAtPrice) compareAtPrice.textContent = variant.formatted_compare_at_price || '';

      if (regularPriceWrapper && salePriceWrapper) {
        regularPriceWrapper.classList.toggle('price__hidden', showComparePrice);
        salePriceWrapper.classList.toggle('price__hidden', !showComparePrice);
      }
    }

    function updateMedia(variant) {
      if (!variant || !variant.featured_media || !variant.featured_media.id) return;

      var section = root.closest('.shopify-section');
      var gallery = section ? section.querySelector('wall-art-gallery') : null;
      if (gallery && typeof gallery.showMedia === 'function') gallery.showMedia(String(variant.featured_media.id));
    }

    function updateAddToCartButton(variant) {
      var productForm = findProductForm();
      var addToCartButton = productForm ? productForm.querySelector('[ref="addToCartButton"]') : null;
      var addToCartPrice = addToCartButton ? addToCartButton.querySelector('[data-add-to-cart-price]') : null;
      var topAreaOptions = productForm ? productForm.querySelector('[data-add-to-cart-selected-options]') : null;
      var topAreaPrice = productForm ? productForm.querySelector('[data-add-to-cart-final-price]') : null;

      if (addToCartButton) {
        addToCartButton.disabled = !variant || variant.available === false;
      }

      if (addToCartPrice && variant && variant.formatted_add_to_cart_price) {
        addToCartPrice.textContent = variant.formatted_add_to_cart_price;
      }

      if (topAreaOptions && variant) {
        topAreaOptions.textContent = [variant.option1, variant.option2, variant.option3].filter(function(option) {
          return option && option !== 'NA';
        }).join(' - ');
      }

      if (topAreaPrice && variant && variant.formatted_add_to_cart_price) {
        topAreaPrice.textContent = variant.formatted_add_to_cart_price;
      }
    }

    function updateStickyAddToCart(variant) {
      var section = root.closest('.shopify-section');
      var stickyAddToCart = section ? section.querySelector('sticky-add-to-cart') : null;
      if (!stickyAddToCart) return;

      stickyAddToCart.dataset.currentVariantId = variant ? variant.id : '';
      stickyAddToCart.dataset.variantAvailable = variant && variant.available ? 'true' : 'false';

      var variantLabel = stickyAddToCart.querySelector('.sticky-add-to-cart__variant');
      if (variantLabel && variant) {
        variantLabel.textContent = [variant.option1, variant.option2, variant.option3].filter(function(option) {
          return option && option !== 'NA';
        }).join(' / ');
      }

      var stickyPrice = stickyAddToCart.querySelector('.sticky-add-to-cart__price');
      if (stickyPrice && variant) stickyPrice.textContent = variant.formatted_add_to_cart_price;

      var stickyButton = stickyAddToCart.querySelector('.sticky-add-to-cart__button');
      if (stickyButton) stickyButton.disabled = !variant || variant.available === false;
    }

    function updateUnlockGifts(variant) {
      var section = root.closest('.shopify-section');
      if (!section || !variant) return;

      section.querySelectorAll('[data-unlock-gifts]').forEach(function(unlockGifts) {
        if (unlockGifts.dataset.productId && unlockGifts.dataset.productId !== String(variantsData.productId)) return;

        unlockGifts.dataset.currentVariantPrice = String(variant.price);

        unlockGifts.querySelectorAll('[data-unlock-gift-item]').forEach(function(item) {
          var threshold = Number(item.dataset.unlockThreshold || 0);
          var isUnlocked = Number(variant.price) >= threshold;
          var tag = item.querySelector('[data-unlock-gift-tag]');

          item.classList.toggle('is-locked', !isUnlocked);

          if (tag) {
            tag.textContent = isUnlocked ? tag.dataset.unlockedLabel : tag.dataset.lockedLabel;
          }
        });
      });
    }

    function setFramedOnlyVisible(framedOnly, isVisible) {
      if (!framedOnly) return;

      if (framedOnly.dataset.animationTimer) {
        window.clearTimeout(Number(framedOnly.dataset.animationTimer));
        delete framedOnly.dataset.animationTimer;
      }

      if (isVisible) {
        if (!framedOnly.hidden && !framedOnly.classList.contains('is-collapsed')) return;

        framedOnly.hidden = false;
        framedOnly.setAttribute('aria-hidden', 'false');
        framedOnly.classList.add('is-collapsed');

        window.requestAnimationFrame(function() {
          framedOnly.classList.remove('is-collapsed');
        });
        return;
      }

      if (framedOnly.hidden) return;

      framedOnly.setAttribute('aria-hidden', 'true');
      framedOnly.classList.add('is-collapsed');

      var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var hideDelay = prefersReducedMotion ? 0 : 260;

      framedOnly.dataset.animationTimer = window.setTimeout(function() {
        framedOnly.hidden = true;
        delete framedOnly.dataset.animationTimer;
      }, hideDelay);
    }

    function applySelectedVariant(options) {
      var variant = findSelectedVariant();

      updateProductFormVariant(variant);

      if (!variant) {
        updateAddToCartButton(null);
        updateStickyAddToCart(null);
        return;
      }

      updatePrice(variant);
      updateMedia(variant);
      updateAddToCartButton(variant);
      updateStickyAddToCart(variant);
      updateUnlockGifts(variant);

      if (options && options.updateUrl) updateUrl(variant);
    }

    function setGroupValue(groupName, value, label) {
      var buttons = root.querySelectorAll('[data-option-group-name="' + groupName + '"]');
      var labelNode = root.querySelector('[data-option-value-label="' + groupName + '"]');

      selectedValues[groupName] = value;

      buttons.forEach(function(button) {
        var isActive = button.dataset.optionValue === value;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      if (labelNode) labelNode.textContent = label;

      if (groupName === 'format') {
        var framedOnly = root.querySelector('[data-framed-only]');

        setFramedOnlyVisible(framedOnly, value === 'framed');
      }
    }

    root.querySelectorAll('[data-option-button]').forEach(function(button) {
      button.addEventListener('click', function() {
        setGroupValue(button.dataset.optionGroupName, button.dataset.optionValue, button.dataset.optionLabel);
        applySelectedVariant({
          updateUrl: true,
        });
      });
    });

    function setupGuideModal(triggerSelector, modalSelector, closeSelector) {
      var trigger = root.querySelector(triggerSelector);
      var modal = root.querySelector(modalSelector);
      var closeButtons = root.querySelectorAll(closeSelector);
      var lastFocusedElement = null;
      var closeTimer = null;

      if (!trigger || !modal) return;

      function openModal() {
        if (closeTimer) {
          window.clearTimeout(closeTimer);
          closeTimer = null;
        }

        lastFocusedElement = document.activeElement;

        if (modal.parentElement !== document.body) {
          document.body.appendChild(modal);
        }

        modal.classList.remove('is-closing');
        modal.hidden = false;

        var closeButton = modal.querySelector(closeSelector);
        if (closeButton) closeButton.focus();
      }

      function closeModal() {
        if (modal.hidden || modal.classList.contains('is-closing')) return;

        var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var closeDelay = prefersReducedMotion ? 0 : 240;

        modal.classList.add('is-closing');

        closeTimer = window.setTimeout(function() {
          modal.hidden = true;
          modal.classList.remove('is-closing');
          closeTimer = null;

          if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
            lastFocusedElement.focus();
          }
        }, closeDelay);
      }

      trigger.addEventListener('click', openModal);

      closeButtons.forEach(function(button) {
        button.addEventListener('click', closeModal);
      });

      document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape' && !modal.hidden) {
          closeModal();
        }
      });
    }

    setupGuideModal('[data-format-help-trigger]', '[data-format-help-modal]', '[data-format-help-close]');
    setupGuideModal('[data-size-guide-trigger]', '[data-size-guide-modal]', '[data-size-guide-close]');

    var activeFormat = root.querySelector('[data-option-group-name="format"][aria-pressed="true"]');

    if (activeFormat) {
      setGroupValue('format', activeFormat.dataset.optionValue, activeFormat.dataset.optionLabel);
    }

    ['size', 'color'].forEach(function(groupName) {
      var activeButton = getActiveButton(groupName);
      if (activeButton) {
        selectedValues[groupName] = activeButton.dataset.optionValue;
      }
    });

    var urlVariant = findVariantById(new URL(window.location.href).searchParams.get('variant'));

    if (urlVariant) {
      setControlsFromVariant(urlVariant);
      applySelectedVariant({
        updateUrl: false,
      });
    } else {
      var syncDefaultVariant = function() {
        applySelectedVariant({
          updateUrl: false,
        });
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', syncDefaultVariant, { once: true });
      } else {
        window.requestAnimationFrame(syncDefaultVariant);
      }
    }
  }

  function initProductOptionPills() {
    document.querySelectorAll('[data-product-option-pills]').forEach(setupProductOptionPills);
  }

  initProductOptionPills();
  document.addEventListener('shopify:section:load', initProductOptionPills);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wall-art-unlock-gifts"] && !Shopify.designMode) return;
  try {
    function getUnlockGiftsVariantData(section) {
    var script = section.querySelector('[data-product-option-pills-variants]');
    if (!script || !script.textContent) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.error('Failed to parse unlock gifts variant data:', error);
      return null;
    }
  }

  function getUnlockGiftsVariantPrice(section, productId) {
    var input = section.querySelector('[data-wall-art-form] input[name="id"]');
    var variantsData = getUnlockGiftsVariantData(section);

    if (!input || !variantsData || !Array.isArray(variantsData.variants)) return null;

    var variant = variantsData.variants.find(function(item) {
      return String(item.id) === String(input.value);
    });

    return variant ? Number(variant.price) : null;
  }

  function updateUnlockGifts(root, price) {
    if (!Number.isFinite(price)) return;

    root.dataset.currentVariantPrice = String(price);

    root.querySelectorAll('[data-unlock-gift-item]').forEach(function(item) {
      var threshold = Number(item.dataset.unlockThreshold || 0);
      var isUnlocked = price >= threshold;
      var tag = item.querySelector('[data-unlock-gift-tag]');

      item.classList.toggle('is-locked', !isUnlocked);

      if (tag) {
        tag.textContent = isUnlocked ? tag.dataset.unlockedLabel : tag.dataset.lockedLabel;
      }
    });
  }

  function refreshUnlockGiftsSection(section, explicitPrice, explicitProductId) {
    if (!section) return;

    section.querySelectorAll('[data-unlock-gifts]').forEach(function(root) {
      if (explicitProductId && root.dataset.productId !== String(explicitProductId)) return;

      var price = Number.isFinite(explicitPrice)
        ? explicitPrice
        : getUnlockGiftsVariantPrice(section, root.dataset.productId);

      if (!Number.isFinite(price)) {
        price = Number(root.dataset.currentVariantPrice);
      }

      updateUnlockGifts(root, price);
    });
  }

  function initUnlockGifts() {
    document.querySelectorAll('[data-unlock-gifts]').forEach(function(root) {
      var section = root.closest('.shopify-section') || document;
      refreshUnlockGiftsSection(section, null, root.dataset.productId);
    });
  }

  document.addEventListener('variant:update', function(event) {
    var section = event.target instanceof HTMLElement ? event.target.closest('.shopify-section') : document;
    var price = event.detail && event.detail.resource ? Number(event.detail.resource.price) : null;
    var productId = event.detail && event.detail.data ? event.detail.data.productId : null;

    refreshUnlockGiftsSection(section, price, productId);
  });

  document.addEventListener('change', function(event) {
    var target = event.target;
    if (!(target instanceof HTMLInputElement) || target.name !== 'id') return;

    window.requestAnimationFrame(function() {
      refreshUnlockGiftsSection(target.closest('.shopify-section'));
    });
  });

  document.addEventListener('click', function(event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var optionButton = target.closest('[data-option-button]');
    if (!optionButton) return;

    window.requestAnimationFrame(function() {
      refreshUnlockGiftsSection(optionButton.closest('.shopify-section'));
    });
  });

  initUnlockGifts();
  document.addEventListener('shopify:section:load', initUnlockGifts);
  } catch(e) { console.error(e); }
})();

})();
